import { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
// api
import { getSingleCoverExtraData } from '../api';
// react router
import { useParams, useLocation } from 'react-router-dom';
// @mui
import { Container } from '@mui/material';
// hooks
import useSettings from '@/hooks/useSettings';
// components
import { Page, HeaderBreadcrumbs } from '@/components';
// custom components
import CoverExtrasCreateEdit from './CoverExtrasCreateEdit';
// types
import type { CoverExtra } from '../types';
// paths
import { PATH_USER } from '@/features/app';
import { PATH_SETTINGS } from '../routes/paths';

// ----------------------------------------------------------------------

export default function ActivityTypesCreate() {
  const { themeStretch } = useSettings();
  const [currentData, setCurrentData] = useState<CoverExtra | {}>({});

  const { pathname } = useLocation();

  const { id } = useParams();

  const isEdit = pathname.includes('edit');

  useEffect(() => {
    const fetchData = async () => {
      const data = await getSingleCoverExtraData(Number(id));
      setCurrentData(data);
    };

    id && fetchData();
  }, [id]);

  return (
    <Page title="Create or Edit cover level extras">
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={!isEdit ? 'Add cover level extra' : 'Edit cover level extra'}
          links={[
            { name: 'Dashboard', href: PATH_USER.root },
            {
              name: 'Settings',
              href: `${PATH_SETTINGS.root}${PATH_SETTINGS.coverExtras}`,
            },
            {
              name: 'Cover Level Extra',
              href: `${PATH_SETTINGS.root}${PATH_SETTINGS.coverExtras}`,
            },
            {
              name: !isEdit
                ? 'Add New Type'
                : isEmpty(currentData)
                ? ''
                : (currentData as CoverExtra).name,
            },
          ]}
        />
        <CoverExtrasCreateEdit
          currentData={currentData as CoverExtra}
          ID={Number(id)}
        />
      </Container>
    </Page>
  );
}
